export const Constants = {
    emptyGuid: "00000000-0000-0000-0000-000000000000",
    emptyString: "",
    defaultSortValue: 100,
    defaultGridPageSize: 25,
    defaultGridPageSizeOptions: [
        {
            text: "10",
            value: 10,
        },
        {
            text: "25",
            value: 25,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
    ],
    minDate: new Date(1753, 1, 1, 0, 0, 0),
    maxDate: new Date(9999, 12, 31, 23, 59, 59),
}